import React, {useContext} from 'react'
import Modal from '../../components/Modal'
import RejectedIcon from '../../assets/images/transaction-rejected.png'
import {CloseIcon} from '../../theme'
import {t} from '@lingui/macro'
import {useLingui} from '@lingui/react'
import {Text} from "rebass";
import {RowBetween} from "../../components/Row";
import {AlertTriangle} from "react-feather";
import {AutoColumn, ColumnCenter} from "../../components/Column";
import {ExternalLink} from '../../theme'
import styled, {ThemeContext} from "styled-components";
import {ButtonPrimary} from "../../components/ButtonLegacy";

interface FailedModalProps {
    isOpen: boolean
    onDismiss: () => void
}

const Wrapper = styled.div`
    width: 100%;
`
const Section = styled(AutoColumn)`
    // padding: 24px;
`

const BottomSection = styled(Section)`
    background-color: ${({theme}) => theme.bg2};
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
`

const ConfirmedIcon = styled(ColumnCenter)`
    padding: 60px 0;
`


export default function FailedModal({isOpen, onDismiss}: FailedModalProps) {
    const {i18n} = useLingui()
    const theme = useContext(ThemeContext)
    return (
        <Modal isOpen={isOpen} onDismiss={onDismiss} padding={28}>
            <Wrapper>
                <Section>
                    <RowBetween>
                        <Text fontWeight={500} fontSize={20}>
                            Error
                        </Text>
                        <CloseIcon onClick={onDismiss}/>
                    </RowBetween>
                    <AutoColumn style={{marginTop: 20, padding: '2rem 0'}} gap="24px" justify="center">
                        <AlertTriangle color={theme.red1} style={{strokeWidth: 1.5}} size={64}/>
                        <Text
                            fontWeight={500}
                            fontSize={16}
                            color={theme.red1}
                            style={{textAlign: 'center', width: '85%'}}
                        >
                            Error Occurred.
                        </Text>
                    </AutoColumn>
                </Section>
                <BottomSection gap="12px">
                    <ButtonPrimary onClick={onDismiss}>Dismiss</ButtonPrimary>
                </BottomSection>
            </Wrapper>
        </Modal>
    )
}
